import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useEventListener from "./use-event-listener";

let translatorElement;

export default function GoogleTranslateHandler({ className = "" }) {
    const { pathname } = useLocation();
    const getScript = () => document.querySelector("script[src^='https://translate.google.com']");

    const element = document.getElementById("google-translate");
    if (element && getScript() && !translatorElement && element.hasChildNodes()) {
        translatorElement = element;
    }

    useEffect(() => {
        if (getScript() && translatorElement) {
            document.getElementById("google-translate").replaceWith(translatorElement);
        }
    }, [pathname]);

    useEffect(() => {
        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement({
                pageLanguage: "en",
                includedLanguages: "es,fr,ko,zh-CN,ar,ru,pt,tl,vi",
                layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            }, "google-translate");

            translatorElement = document.getElementById("google-translate");
        };

        if (!getScript()) {
            const script = document.createElement("script");
            script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }
    }, []);

    useEventListener(window, "error", e => {
        if (e.filename.includes("translate.googleapis.com") || e.filename.includes("translate.google.com")) {
            e.preventDefault();
        }
    });

    return <div id="google-translate" className={`translate-y-px ${className}`} />;
}
